import React from 'react'
import PropTypes from 'prop-types'
import {
  Form,
  Popup
} from 'semantic-ui-react'

const BaseCheckboxGroupField = ({
  labelTxt,
  name,
  onChange,
  options,
  popupTxt,
  value
}) => {
  const onBoxChange = (e, { checked, value: cbValue }) => {
    const newVals = new Set(value || []);
    checked ? newVals.add(cbValue) : newVals.delete(cbValue);
    onChange(e, { name, value: Array.from(newVals), type: "checkboxgroup" });
  };

  return (
    <Form.Field>
      <Popup
        trigger={<label>{labelTxt}</label>}
        content={popupTxt}
      />
      <div style={ { margin: "1em 0", paddingLeft: "1em" }} >
        {
          options.map(o => {
            const v = typeof o === "string" ? o : o.value;
            const label = typeof o === "string" ? o : o.label;
            return (
              <Form.Checkbox
                key={ v }
                label={ { children: label } }
                value={ v }
                checked={ value.includes(v) }
                name={ `${name}[${v}]` }
                onChange={ onBoxChange }
              />
            );
          })
        }
      </div>
    </Form.Field>
  );
};

BaseCheckboxGroupField.propTypes = {
  popupTxt: PropTypes.string.isRequired,
  labelTxt: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({ label: PropTypes.string.isRequired, value: PropTypes.string.isRequired })
  ])).isRequired,
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default BaseCheckboxGroupField;



// WEBPACK FOOTER //
// ./webAdmin/forms/baseCheckboxGroup.js